/* Primydeals - analyse du parcours (PostHog) : boutique primydeals.com + checkout.primydeals.com.
   Source : Ecom/_shared/posthog-lp/pd-posthog.tpl.js (build_funnel.py). CRO_PLAN §9c. Ne pas editer les copies.
   Regles : ne bloque jamais la page (tout en try/catch, chargement async) ; pas d'autocapture, pas de heatmap,
   pas de dead clicks PostHog (les nôtres : engage.js, 05/10) ; enregistrement de sessions echantillonne (cookie partage boutique <-> checkout) ;
   jamais d'e-mail ni de nom (person_profiles identified_only, aucun identify()). */
(function () {
  'use strict';
  try {
    if (window.__pdPh) return;
    window.__pdPh = 1;
    var KEY = 'phc_mQ3XTddyqbgvfcN9er5VDRAJDTSANsiuAYatjmnUqCy2', HOST = 'https://us.i.posthog.com', REC = 0.25;
    var loc = window.location;
    if (!/^https?:$/.test(loc.protocol) || !/(^|\.)primydeals\.com$/.test(loc.hostname)) return;
    var IS_CHECKOUT = /^checkout\./.test(loc.hostname);
    var ROOT = '.primydeals.com';
    var SECURE = loc.protocol === 'https:' ? '; Secure' : '';

    window.phCapture = function (name, props) {
      try { if (window.posthog && window.posthog.capture) window.posthog.capture(name, props || {}); } catch (e) {}
    };

    function gc(n) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    }
    function sc(n, v) { try { document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; domain=' + ROOT + '; SameSite=Lax' + SECURE; } catch (e) {} }

    var q = new URLSearchParams(loc.search);

    /* 1. Identite venue d'une LP (ph_did / ph_sid) : elle remplace l'identite locale pour que le parcours reste continu */
    var ID = /^[0-9A-Za-z_-]{8,80}$/;
    var did = q.get('ph_did'), sid = q.get('ph_sid'), boot = null;
    if (did && ID.test(did)) {
      boot = { distinctID: did };
      if (sid && ID.test(sid)) boot.sessionID = sid;
      try {
        var ck = 'ph_' + KEY + '_posthog';
        document.cookie = ck + '=; Max-Age=0; path=/; domain=' + ROOT;
        document.cookie = ck + '=; Max-Age=0; path=/';
        window.localStorage.removeItem(ck);
      } catch (e) {}
    }
    /* 06/10 : test A/B des LP (« LP+ ») : bras transmis par la LP dans le lien, gardé en super-propriété (cookie partagé boutique <-> checkout) */
    var LPAB = q.get('lp_ab');
    if (q.has('ph_did') || q.has('ph_sid') || q.has('lp_ab')) {
      var clean = new URLSearchParams(loc.search);
      clean.delete('ph_did'); clean.delete('ph_sid'); clean.delete('lp_ab');
      var cs = clean.toString();
      try { window.history.replaceState(window.history.state, '', loc.pathname + (cs ? '?' + cs : '') + loc.hash); } catch (e) {}
    }

    /* 2. Echantillon d'enregistrement : decide une fois par navigation, cookie de session partage boutique <-> checkout */
    var rec = gc('pd_ph_rec');
    if (rec === null) { rec = Math.random() < REC ? '1' : '0'; sc('pd_ph_rec', rec); }

    function stepFor(p) {
      if (IS_CHECKOUT) return /\/confirmation/.test(p) ? 'confirmation' : 'checkout';
      if (/^\/products\//.test(p)) return 'pdp';
      if (/^\/cart/.test(p)) return 'cart';
      if (/^\/collections/.test(p)) return 'collection';
      if (p === '/') return 'home';
      return 'other';
    }
    function handleFor(p) {
      var m = p.match(/^\/products\/([^\/?#]+)/);
      var h = m ? m[1] : (new URLSearchParams(loc.search).get('product') || '');
      try {
        if (h) window.sessionStorage.setItem('pd_ph_handle', h); else h = window.sessionStorage.getItem('pd_ph_handle') || '';
      } catch (e) {}
      return h;
    }

    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    var cfg = {
      api_host: HOST, defaults: '2026-05-30', person_profiles: 'identified_only',
      autocapture: false, capture_pageview: true, capture_pageleave: true,
      enable_heatmaps: false, capture_dead_clicks: false, capture_exceptions: false,
      capture_performance: { web_vitals: true, network_timing: false },   /* 05/10 : vitesse des fiches et du checkout (LCP, INP, CLS, FCP) */
      disable_surveys: true, advanced_disable_flags: true,
      disable_session_recording: rec !== '1',
      session_recording: { maskAllInputs: true },
      persistence: 'cookie',            /* cookie seul, partage primydeals.com <-> checkout.primydeals.com : une seule source d'identite */
      cross_subdomain_cookie: true,
      before_send: function (cp) {
        try {
          var pr = cp.properties = cp.properties || {};
          pr.funnel_step = stepFor(loc.pathname);
          var h = handleFor(loc.pathname);
          if (h) pr.handle = h;
          pr.site = IS_CHECKOUT ? 'checkout.primydeals.com' : 'primydeals.com';
          if ((LPAB === 'new' || LPAB === 'old') && !pr.lp_ab) pr.lp_ab = LPAB;   /* 1re page vue, envoyée avant le register */
          if (!IS_CHECKOUT && h) pr.pdp_view = document.documentElement.classList.contains('pdx') ? 'pdx' : 'default';  /* design de fiche réellement affiché (test A/B pdx, 29/09) */
          if (!IS_CHECKOUT && h) pr.gift_view = document.documentElement.classList.contains('pdeb') ? 'eb' : 'gift';  /* offre réellement affichée (test cadeau ou guides, 03/10) */
          /* 05/10 : test A/B du checkout (design a contre l'actuel) : bras tiré par la page de checkout (localStorage pd_co_ab), joint à chaque événement du checkout */
          if (IS_CHECKOUT) { try { var coab = window.localStorage.getItem('pd_co_ab'); if (coab === 'a' || coab === 'ctl') pr.co_design = coab; } catch (e) {} }
          /* 05/10 : engagement de page (sections, galerie, clics morts / rageurs) joint sans événement en plus (engage.js) */
          if (window.__pdEng && /^(\$pageleave|add_to_cart|gift_addon_popup|add_payment_info|payment_error)$/.test(cp.event)) {
            var en = window.__pdEng.snap(); for (var ek in en) pr[ek] = en[ek];
          }
        } catch (e) {}
        return cp;
      }
    };
    if (boot) cfg.bootstrap = boot;
    window.posthog.init(KEY, cfg);
    if (LPAB === 'new' || LPAB === 'old') { try { window.posthog.register({ lp_ab: LPAB }); } catch (e) {} }

    /* 05/10 (CRO_PLAN §11) : engagement de page. Fiche : galerie, blocs de la colonne produit, sections du bas.
       Checkout : clics morts / rageurs seulement, sans aucun texte. */
    /* ENGAGEMENT DE PAGE (05/10/2026, CRO_PLAN §11) : sections vues + temps passé, galerie produit, accordéons ouverts,
   clics morts (sur ce qui n'est pas cliquable) et clics rageurs. Source unique : Ecom/_shared/posthog-lp/engage.js,
   injecté dans pd-posthog.tpl.js (boutique + checkout, build_funnel.py) et dans le bloc des LP (apply.py).
   Coût : aucun événement en plus. L'état est joint par before_send à $pageleave et aux événements clés
   (add_to_cart, lp_cta_click...). Seul événement ajouté : rage_click (3 clics en 1 s au même endroit, 5 max par page).
   Jamais de valeur saisie ; texte des éléments seulement si C.text (jamais sur le checkout). Ne bloque jamais la page. */
window.__pdEngInit = function (C) {
  try {
    if (window.__pdEng || !('IntersectionObserver' in window)) return;
    var t0 = Date.now(), vis = !document.hidden, S = [], order = [], acc = [], dead = {}, deadN = 0, rageN = 0, clicks = [];
    var G = { n: 0, seen: {}, cnt: 0, max: 0, how: {}, zoom: 0 }, extra = {};
    var cap = C.cap || function () {};
    var vh = function () { return window.innerHeight || document.documentElement.clientHeight || 800; };
    var cls = function (el) {
      var c = (typeof el.className === 'string' ? el.className : '').split(/\s+/);
      for (var i = 0; i < c.length; i++) if (/^[a-z][a-z_-]{2,30}$/i.test(c[i])) return c[i];
      return '';
    };
    var secOf = function (el) {
      for (var i = 0; i < S.length; i++) if (S[i].el.contains(el)) return S[i].n;   /* S est trié du plus petit au plus grand bloc */
      return '';
    };
    var desc = function (el) {
      var t = el.tagName ? el.tagName.toLowerCase() : '?', c = cls(el), s = secOf(el), x = '';
      if (C.text && t !== 'img' && el.childElementCount < 3) x = String(el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 24);
      if (t === 'img') x = String(el.getAttribute('alt') || '').slice(0, 24);
      return ((s ? s + '>' : '') + t + (c ? '.' + c : '') + (x ? ' "' + x + '"' : '')).slice(0, 80);
    };

    /* 1. sections : vue = moitié du bloc visible ou moitié de l'écran couverte ; temps compté onglet visible seulement */
    var now = function () { return Date.now(); };
    var settle = function (s, t) { if (s.st) { s.ms += t - s.st; s.st = vis && s.on ? t : 0; } };
    var io = new IntersectionObserver(function (es) {
      var t = now();
      es.forEach(function (e) {
        var s = e.target.__phs; if (!s) return;
        var on = e.isIntersecting && (e.intersectionRatio >= 0.5 || e.intersectionRect.height >= 0.5 * vh());
        if (on && !s.on) { s.on = 1; s.st = vis ? t : 0; if (!s.seen) { s.seen = 1; order.push(s.n); } }
        else if (!on && s.on) { settle(s, t); s.on = 0; s.st = 0; }
      });
    }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });
    var names = {};
    var add = function (el, n) {
      if (!el || el.__phs || !n || S.length >= 30) return;
      if (names[n]) n = n + '_' + (++names[n]); else names[n] = 1;
      var s = { el: el, n: n, ms: 0, on: 0, st: 0, seen: 0 };
      el.__phs = s; S.push(s); io.observe(el);
    };
    var scan = function () {
      try {
        (C.sections || []).forEach(function (p) {
          try {
            var els = typeof p[1] === 'function' ? p[1]() : document.querySelectorAll(p[1]);
            for (var i = 0; i < els.length && i < (p[2] || 1); i++) add(els[i], p[0]);
          } catch (e) {}
        });
        if (C.auto) {
          var els = document.querySelectorAll(C.auto);
          for (var i = 0; i < els.length; i++) {
            var el = els[i]; if (el.__phs || el.offsetHeight < 80) continue;
            var n = C.autoName ? C.autoName(el) : (el.id || cls(el));
            if (n) add(el, String(n).toLowerCase().slice(0, 30));
          }
        }
        /* ordre par taille croissante : le plus petit bloc qui contient un clic donne son nom */
        S.sort(function (a, b) { return (a.el.offsetHeight * a.el.offsetWidth) - (b.el.offsetHeight * b.el.offsetWidth); });
      } catch (e) {}
    };
    document.addEventListener('visibilitychange', function () {
      var t = now(); vis = !document.hidden;
      S.forEach(function (s) { if (!vis) settle(s, t); else if (s.on) s.st = t; });
    });

    /* 2. galerie produit (boutique) : images réellement vues (60 % visibles), dernière atteinte, comment (swipe / flèche / miniature), zoom */
    var gio = null, lastTouch = 0;
    var galScan = function () {
      if (!C.gallery) return;
      try {
        var li = document.querySelectorAll(C.gallery.slides);
        if (!li.length || gio) return;
        G.n = li.length;
        gio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.intersectionRatio < 0.6) return;
            var k = e.target.__phg; if (!k || G.seen[k]) return;
            G.seen[k] = 1; G.cnt++; if (k > G.max) G.max = k;
          });
        }, { threshold: [0.6] });
        for (var i = 0; i < li.length; i++) { li[i].__phg = i + 1; gio.observe(li[i]); }
        var ul = document.querySelector(C.gallery.track);
        if (ul) ul.addEventListener('scroll', function () { if (now() - lastTouch < 1500) G.how.swipe = 1; }, { passive: true });
      } catch (e) {}
    };
    document.addEventListener('touchstart', function (e) {
      if (C.gallery && e.target && e.target.closest && e.target.closest(C.gallery.root)) lastTouch = now();
    }, { passive: true, capture: true });

    /* 3. accordéons / FAQ ouverts (details natifs + FAQ des LP) */
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open || acc.length >= 8) return;
      var sm = d.querySelector('summary'), ti = sm && sm.querySelector('h2,h3,h4,h5,.accordion__title');
      acc.push((secOf(d) ? secOf(d) + ':' : '') + String((ti || sm || {}).textContent || '').replace(/\s+/g, ' ').trim().slice(0, 30));
    }, true);

    /* 4. clics : galerie, clics morts, clics rageurs */
    var INTER = 'a,button,input,select,textarea,label,summary,option,[role=button],[role=tab],[role=link],[role=checkbox],[role=radio],[onclick],modal-opener,video,audio,iframe,[contenteditable]';
    var clickable = function (el) {
      if (el.closest(INTER)) return true;
      for (var i = 0, x = el; x && x !== document.body && i < 4; i++, x = x.parentElement) {
        try { if (window.getComputedStyle(x).cursor === 'pointer') return true; } catch (e) { return true; }
      }
      return !!(C.clickable && el.closest(C.clickable));
    };
    document.addEventListener('click', function (e) {
      try {
        var el = e.target, t = now();
        if (!el || !el.closest) return;
        if (C.gallery && el.closest(C.gallery.root)) {
          if (el.closest(C.gallery.arrows)) G.how.arrow = 1;
          else if (el.closest(C.gallery.thumbs)) G.how.thumb = 1;
          else if (el.closest(C.gallery.zoom)) G.zoom++;
        }
        if (C.extraClicks) C.extraClicks(el, extra);
        clicks = clicks.filter(function (c) { return t - c.t < 1000; });
        clicks.push({ t: t, x: e.clientX, y: e.clientY });
        var near = clicks.filter(function (c) { return Math.abs(c.x - e.clientX) < 30 && Math.abs(c.y - e.clientY) < 30; }).length;
        if (near === 3 && rageN < 5) { rageN++; cap('rage_click', { on: desc(el), sec: secOf(el), n: rageN, t_s: Math.round((t - t0) / 1000) }); }
        if (el !== document.documentElement && el !== document.body && !clickable(el)) { var d = desc(el); dead[d] = (dead[d] || 0) + 1; deadN++; }
      } catch (err) {}
    }, true);

    /* 5. état joint aux événements (before_send) */
    window.__pdEng = {
      bump: function (k) { extra[k] = (extra[k] || 0) + 1; },
      snap: function () {
        var t = now(), ms = {}, deep = '', deepTop = -1;
        S.forEach(function (s) {
          settle(s, t);
          if (s.ms >= 300) ms[s.n] = Math.round(s.ms / 100) / 10;
          if (s.seen) { var top = 0; try { top = s.el.getBoundingClientRect().top + window.pageYOffset; } catch (e) {} if (top > deepTop) { deepTop = top; deep = s.n; } }
        });
        var o = { eng_s: Math.round((t - t0) / 1000), sec_seen: order.join(','), sec_deep: deep, sec_ms: ms, dead_n: deadN, rage_n: rageN };
        if (deadN) o.dead_top = Object.keys(dead).sort(function (a, b) { return dead[b] - dead[a]; }).slice(0, 3).map(function (k) { return k + ' x' + dead[k]; }).join(' | ');
        if (acc.length) o.acc_open = acc.join(' | ');
        if (G.n) { o.gal_n = G.n; o.gal_seen = G.cnt; o.gal_max = G.max; o.gal_how = Object.keys(G.how).join(',') || 'none'; o.gal_zoom = G.zoom; }
        for (var k in extra) o[k] = extra[k];
        return o;
      }
    };
    var go = function () { scan(); galScan(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
    window.addEventListener('load', function () { setTimeout(go, 1500); });
  } catch (err) { /* jamais bloquant */ }
};
    window.__pdEngInit({
      cap: window.phCapture, text: !IS_CHECKOUT,
      sections: IS_CHECKOUT ? [] : [
        ['gallery', 'media-gallery'], ['price', '.product-page-price'], ['offers', 'quantity-breaks-v2'], ['guides', '.pdeb-rows'],
        ['atc', 'product-form.main-product-form .product-form__buttons'], ['top_review', '.review-items-container'],
        ['videos', function () { var v = document.querySelector('.product__info-container .video-container'); return v && v.closest('.splide') ? [v.closest('.splide')] : []; }],
        ['details', '.product__info-container .product__accordion', 6]
      ],
      auto: IS_CHECKOUT ? null : '[id^="shopify-section-template--"]',
      autoName: function (el) {
        var m = el.id.match(/__([a-z0-9_]+)$/i); if (!m) return '';
        var n = m[1].replace(/_(?=[A-Za-z0-9]*[A-Z0-9])[A-Za-z0-9]{6}$/, '');   /* suffixe aléatoire Shopify (_QYjFtf), pas _badges */
        return /^(main|announcement_bar|hide_header_footer|custom_liquid)$/.test(n) ? '' : n;
      },
      gallery: IS_CHECKOUT ? null : { root: 'media-gallery', slides: 'media-gallery .product__media-list > li.product__media-item', track: 'media-gallery .product__media-list',
        arrows: '.slider-button', thumbs: '.thumbnail-list__item, .thumbnail', zoom: 'modal-opener, .product__modal-opener' },
      clickable: 'quantity-breaks-v2, .splide, sticky-atc',
      extraClicks: function (el, x) { if (el.closest('.pdeb-see')) x.guides_see = (x.guides_see || 0) + 1; }
    });

    /* 3. Attribution : UTM et identifiants de clic de la page d'arrivee, gardes sur tous les evenements suivants */
    var A = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'campaign_id', 'adgroup_id', 'tw_source', 'tw_campaign'].forEach(function (k) {
      var v = q.get(k); if (v) A[k] = v;
    });
    /* test A/B de la fiche (29/09, CRO_PLAN §8g) : bras tiré sur la LP (pd_ab = pdx | ctl), gardé sur tous les événements suivants, checkout compris */
    var ab = q.get('pd_ab'); if (ab === 'pdx' || ab === 'ctl') A.pd_ab = ab;
    /* test « cadeau ou guides » (03/10, CRO_PLAN §11) : bras tiré sur la LP (pd_gift_ab = gift | eb), gardé de la même façon */
    var gab = q.get('pd_gift_ab'); if (gab === 'gift' || gab === 'eb') A.pd_gift_ab = gab;
    ['ad_utm_source', 'ad_utm_campaign'].forEach(function (k) { var v = q.get(k); if (v) A[k] = v; });  /* valeurs de la pub quand la LP a déjà la clé (transfert UTM v2) */
    if (q.get('gclid') || q.get('gbraid') || q.get('wbraid')) A.from_google = 'yes';
    if (q.get('fbclid')) A.from_meta = 'yes';
    if (q.get('msclkid')) A.from_bing = 'yes';
    try {
      if (window.Shopify) {
        if (window.Shopify.country) A.market = window.Shopify.country;
        if (window.Shopify.theme && window.Shopify.theme.role) A.theme_role = window.Shopify.theme.role;
      }
    } catch (e) {}
    if (Object.keys(A).length) window.posthog.register(A);

    /* 4. Boutique seulement : ajout au panier, choix d'offre, clic des barres d'achat */
    if (!IS_CHECKOUT) {
      var offerLabel = function () {
        var chk = document.querySelector('quantity-breaks-v2 input[name="quantity"]:checked');
        var l = chk && chk.nextElementSibling;
        var t = l && l.querySelector ? l.querySelector('.vs2-label') : null;
        return t ? t.textContent.trim() : '';
      };
      var atc = function (init) {
        var lines = 0, units = 0, gift = false, addon = false;
        try {
          var b = init && init.body;
          if (typeof b === 'string') {
            var j = JSON.parse(b), items = j.items || [j];
            items.forEach(function (it) {
              lines++; units += +it.quantity || 1;
              if (it.properties && it.properties._free_gift) gift = true;
              if (it.properties && it.properties._addon) addon = true;
            });
          } else if (b && typeof b.get === 'function') { lines = 1; units = +b.get('quantity') || 1; }
        } catch (e) {}
        window.phCapture('add_to_cart', { lines: lines, units: units, has_gift: gift, has_addon: addon, offer: offerLabel() });
      };
      var of = window.fetch;
      if (typeof of === 'function') {
        window.fetch = function (input) {
          var p = of.apply(this, arguments), init = arguments[1];
          try {
            var u = typeof input === 'string' ? input : ((input && input.url) || '');
            if (u.indexOf('/cart/add') > -1) p.then(function (r) { try { if (r && r.ok) atc(init); } catch (e) {} }, function () {});
          } catch (e) {}
          return p;
        };
      }
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (t && /^options\[/.test(t.name || '') && window.__pdEng) window.__pdEng.bump('var_n');   /* 05/10 : changements de variante */
        if (t && t.name === 'quantity' && t.checked && t.closest && t.closest('quantity-breaks-v2')) window.phCapture('offer_select', { offer: (function () { var l = t.nextElementSibling, x = l && l.querySelector ? l.querySelector('.vs2-label') : null; return x ? x.textContent.trim() : ''; })() });
      }, true);
      document.addEventListener('click', function (e) {
        var el = e.target && e.target.closest ? e.target.closest('.sticky-atc__scroll-btn,[data-pdx-scroll]') : null;
        if (el) window.phCapture('cta_scroll', { source: el.matches('.sticky-atc__scroll-btn') ? 'sticky' : 'page_cta' });
      }, true);
      /* 05/10 : vidéos UGC de la fiche. Les vidéos démarrent en muet (lecture auto) : seul ce que fait le visiteur compte.
         video_play (1re lecture, muette ou non) · video_click (1er clic sur une vidéo) · video_unmute (son activé) ·
         video_progress 25/50/75/95 % et video_complete UNIQUEMENT avec le son (vrai visionnage). slot = n° de la vidéo dans la page. */
      (function () {
        var W = new WeakMap(), n = 0;
        function st(v) { var s = W.get(v); if (!s) { s = { i: ++n, m: {} }; W.set(v, s); } return s; }
        function src(v) { return String(v.currentSrc || v.src || '').split('?')[0].slice(-70); }
        function hook(v) {
          if (!v || v.tagName !== 'VIDEO' || v.__phv) return;
          v.__phv = 1; var s = st(v);
          v.addEventListener('timeupdate', function () {
            if (v.muted || !v.duration || !isFinite(v.duration)) return;
            var pc = 100 * v.currentTime / v.duration;
            [25, 50, 75, 95].forEach(function (t) { if (pc >= t && !s.m[t]) { s.m[t] = 1; window.phCapture('video_progress', { pct: t, slot: s.i, src: src(v) }); } });
          });
          v.addEventListener('volumechange', function () { if (!v.muted && !s.u) { s.u = 1; window.phCapture('video_unmute', { slot: s.i, src: src(v), at: Math.round(v.currentTime) }); } });
          v.addEventListener('ended', function () { if (!v.muted && !s.e) { s.e = 1; window.phCapture('video_complete', { slot: s.i, src: src(v) }); } });
        }
        document.addEventListener('play', function (e) {
          var v = e.target; if (!v || v.tagName !== 'VIDEO') return; hook(v);
          var s = st(v); if (!s.p) { s.p = 1; window.phCapture('video_play', { slot: s.i, src: src(v), muted: !!v.muted }); }
        }, true);
        document.addEventListener('pointerdown', function (e) {
          var t = e.target, box = t && t.closest ? t.closest('video-player, .video-player, video, .splide__slide') : null;
          var v = box ? (box.tagName === 'VIDEO' ? box : box.querySelector && box.querySelector('video')) : null;
          if (!v) return; hook(v); var s = st(v);
          if (!s.c) { s.c = 1; window.phCapture('video_click', { slot: s.i, src: src(v), muted: !!v.muted }); }
        }, true);
      })();
    }
  } catch (err) { /* jamais bloquant */ }
})();
